import * as classnames from 'classnames/bind'
import * as React from 'react'
import styles from './image.scss'
const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  source: string | null
  ratio?: '1-1' | '16-9' | '3-2' | 'fb-ratio'
}
class Image extends React.Component<IProps> {
  public render() {
    const { source, ratio, className } = this.props
    return (
      <div className={cx('image-container', `image-container--${ratio}`, className)}>
        <div className={cx('image')} style={{ backgroundImage: `url('${source}')` }} />
      </div>
    )
  }
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Image/index.tsx